import React, { createContext, useReducer } from "react";
import {
  attempAccountConfirmation,
  attempLogin,
  attempRegister,
  attempForgotPassword,
  attempResetPassword,
  attempChangeName,
  attempChangePassword,
} from "../api/auth";
import AuthReducer from "./AuthReducer";

import {
  SET_USER,
  RESET_ERROR,
  RESET_USER,
  AUTH_FETCH_START,
  AUTH_FETCH_SUCCESS,
  AUTH_FETCH_FAILURE,
} from "./AuthReducer";

const initialState = {
  currentUser: null, //The current logged user
  loading: false,
  error: null,
};

export const AuthContext = createContext(initialState);

export const AuthProvider = ({ children }) => {
  const [state, dispatch] = useReducer(AuthReducer, initialState);

  const setUserFromStorage = () => {
    const user = localStorage.getItem("user");

    if (user) {
      dispatch({ type: SET_USER, payload: JSON.parse(user) });
    }
  };

  // Login user and store the user in the state and in localstorage if remember me is checked
  const loginUser = async ({ email, password, rememberMe }) => {
    dispatch({ type: AUTH_FETCH_START });
    try {
      const user = await attempLogin({ email, password });
      dispatch({
        type: SET_USER,
        payload: user,
      });
      if (rememberMe) {
        localStorage.setItem("user", JSON.stringify(user));
        localStorage.setItem("loginMethod", "normal");
      }
      return user;
    } catch (err) {
      dispatch({ type: AUTH_FETCH_FAILURE, payload: err });
    }
  };

  const registerUser = async ({ email, firstName, lastName, password }) => {
    dispatch({ type: AUTH_FETCH_START });
    try {
      const user = await attempRegister({
        email,
        firstName,
        lastName,
        password,
      });
      dispatch({ type: AUTH_FETCH_SUCCESS });
      return user;
    } catch (err) {
      dispatch({ type: AUTH_FETCH_FAILURE, payload: err });
    }
  };

  async function confirmAccount(confirmationCode) {
    dispatch({ type: AUTH_FETCH_START });
    try {
      const user = await attempAccountConfirmation({ confirmationCode });
      dispatch({ type: AUTH_FETCH_SUCCESS });
      return user;
    } catch (err) {
      dispatch({ type: AUTH_FETCH_FAILURE, payload: err });
    }
  }

  async function forgotPassword(email) {
    dispatch({ type: AUTH_FETCH_START });
    try {
      const data = await attempForgotPassword({ email });
      dispatch({ type: AUTH_FETCH_SUCCESS });
      return data;
    } catch (err) {
      dispatch({ type: AUTH_FETCH_FAILURE, payload: err });
    }
  }

  async function resetPassword(resetPasswordToken, password) {
    dispatch({ type: AUTH_FETCH_START });
    try {
      const data = await attempResetPassword({ resetPasswordToken, password });
      dispatch({ type: AUTH_FETCH_SUCCESS });
      return data;
    } catch (err) {
      dispatch({ type: AUTH_FETCH_FAILURE, payload: err });
    }
  }

  async function changeName(firstName, lastName) {
    dispatch({ type: AUTH_FETCH_START });
    try {
      const user = await attempChangeName({ firstName, lastName });
      dispatch({
        type: SET_USER,
        payload: user,
      });

      localStorage.setItem("user", JSON.stringify(user));

      return user;
    } catch (err) {
      dispatch({ type: AUTH_FETCH_FAILURE, payload: err });
    }
  }

  async function changePassword(newPassword, oldPassword) {
    dispatch({ type: AUTH_FETCH_START });
    try {
      const data = await attempChangePassword({ newPassword, oldPassword });
      dispatch({ type: AUTH_FETCH_SUCCESS });
      return data;
    } catch (err) {
      dispatch({ type: AUTH_FETCH_FAILURE, payload: err });
    }
  }

  function resetError() {
    dispatch({ type: RESET_ERROR });
  }

  // Logout user and remove the user from the state and local storage
  const logoutUser = () => {
    localStorage.removeItem("user");
    localStorage.removeItem("loginMethod");

    dispatch({ type: RESET_USER });
  };

  return (
    <AuthContext.Provider
      value={{
        currentUser: state.currentUser,
        loading: state.loading,
        error: state.error,
        loginUser,
        logoutUser,
        registerUser,
        setUserFromStorage,
        confirmAccount,
        forgotPassword,
        resetPassword,
        changeName,
        changePassword,
        resetError,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};
